export default {
    // BASE_URL_PREFIX: 'https://lucky.peopletech.cn'
    BASE_URL_PREFIX: 'https://newsdata.peopletech.cn'
};



// WEBPACK FOOTER //
// ./src/common/config/prod.js